import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { AppSettingService } from '../services/app-setting.service';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ClaimService {


  constructor(private http: HttpClient) { }

  getClaim(claimId: any, userId: any): Observable<any> {
    return this.http
      .get(AppSettingService.getClaimDetailUri + "?claimId=" + claimId + "&userId=" + userId).pipe(catchError(this.error));

  }
  validateAddClaimNote(model:any){
    return this.http
    .post(AppSettingService.validateAddClaimNoteUri,model).pipe(catchError(this.error));

  }
  deleteClaim(claimId: any): Observable<any> {

    return this.http
      .get(AppSettingService.deleteClaimUri + "?claimId=" + claimId).pipe(catchError(this.error));

  }

  getUsers(searchTerm: any): Observable<any> {
    return this.http
      .get(AppSettingService.getUserClaimsUri + "?searchTerm=" + searchTerm).pipe(catchError(this.error));

  }

  getPatients(searchTerm: any, type: any): Observable<any> {
    return this.http
      .get(AppSettingService.getPatientsUri + "?searchText=" + searchTerm + "&type=" + type).pipe(catchError(this.error));

  }

  getPatientAuthorizations(patientId: any, claimId: any): Observable<any> {
    return this.http
      .get(AppSettingService.getPatientAuthorizationUri + "?userId=" + patientId + "&claimId=" + claimId).pipe(catchError(this.error));

  }
  getPatientHistory(userId: any): Observable<any> {
    return this.http
      .get(AppSettingService.getPatientHistoryUri + "?userId=" + userId).pipe(catchError(this.error));

  }
  addClaim(model: any): Observable<any> {
    return this.http
      .post(AppSettingService.addClaimUri, model).pipe(catchError(this.error));

  }
  error(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(error);
    return throwError({ error: error.error, status: error.status });
  }
  emailClaims(model:any){

    return this.http.post(AppSettingService.emailClaimsUri,model).pipe(catchError(this.error))
  }

}